import React from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import AssignmentIcon from '@material-ui/icons/Assignment';
import BuildIcon from '@material-ui/icons/Build';
import { Container } from '@michelin/acid-components';
import { useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/v3/PageTitle/PageTitle';
import GLOBAL_CONFIG from 'global-variables';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardGrid: {
      display: 'flex',
      gap: '1.5rem',
      flexWrap: 'wrap',
      padding: '1.5rem 0',
      justifyContent: 'center',
    },
    card: {
      flex: '1 1',
      maxWidth: 480,
      minHeight: 180,
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('xs')]: {
        flex: '1 1 100%',
        maxWidth: '100%',
      },
    },
    cardAction: {
      flex: 1,
      display: 'flex',
      alignItems: 'flex-start',
    },
    cardContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      width: '100%',
      padding: '1.5rem',
    },
    icon: {
      fontSize: 40,
      marginBottom: '1rem',
    },
    iconBuild: {
      color: theme.palette.secondary.main,
    },
    iconAssignment: {
      color: theme.palette.warning.main,
    },
    cardTitle: {
      fontWeight: 600,
      marginBottom: '0.5rem',
    },
  }),
);

export function MyAdminModule() {
  const { t } = useTranslation();
  const classes = useStyles();

  const cards = [
    {
      title: t('ONCall Mechanical Admin'),
      description: t('Review Mechanical Estimate Invoices.'),
      icon: <BuildIcon className={`${classes.icon} ${classes.iconBuild}`} />,
      url: GLOBAL_CONFIG.onCallMechanicalUrl,
    },
    {
      title: t('DTSM'),
      description: t('Digital Tire Service Manuals.'),
      icon: <AssignmentIcon className={`${classes.icon} ${classes.iconAssignment}`} />,
      url: GLOBAL_CONFIG.dtsmUrl,
    },
  ];

  return (
    <>
      <PageTitle
        eyebrow={t('Settings')}
        title={t('My Admin Area')}
        subtitle={t('MOCM Admin, DTSM and additional information')}
      />
      <Container>
        <div className={classes.cardGrid}>
          {cards.map((card) => {
            const prodOrStagingCards = card.title === t('ONCall Mechanical Admin');
            const isProdOrStaging = GLOBAL_CONFIG.env === 'production' || GLOBAL_CONFIG.env === 'staging';
            const prodURLWarning = `${t('THIS LINK IS PRODUCTION ONLY')}`;
            const cardElement = (
              <Card key={card.title} className={classes.card} variant="outlined">
                <CardActionArea className={classes.cardAction} onClick={() => card.url && window.open(card.url)}>
                  <CardContent className={classes.cardContent}>
                    {card.icon}
                    <Typography variant="subtitle1" className={classes.cardTitle}>
                      {card.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {card.description}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            );
            return prodOrStagingCards && !isProdOrStaging ? (
              <Tooltip key={card.title} title={prodURLWarning}>
                <div className={classes.card}>{cardElement}</div>
              </Tooltip>
            ) : (
              cardElement
            );
          })}
        </div>
      </Container>
    </>
  );
}
